import requestToApi, {
  ApiCallParams,
  apiPostWithDetailErrorResponse
} from "../../services/baseService";
import { UserRegistrationVm, LoginUserVm } from "./domain";

export async function postRegistrationData(
  params: ApiCallParams<UserRegistrationVm>
) {
  const response = await requestToApi(
    "/api/registration",
    "post",
    false,
    params
  );

  if (response) {
    return response;
  }

  return false;
}

export async function postLoginData(params: ApiCallParams<LoginUserVm>) {
  // const response = await requestToApi(
  //   "/api/login/authenticate",
  //   "post",
  //   false,
  //   params
  // );

  const response = await apiPostWithDetailErrorResponse(
    "/api/login/authenticate",
    {
      payload: params
    }
  );

  return response;
}

export async function postTwoFactorLoginCode(params: ApiCallParams<string>) {
  // const response = await requestToApi(
  //   `/api/login/authenticate/2factor/${params}`,
  //   "post",
  //   false
  // );

  const response = await apiPostWithDetailErrorResponse(
    `/api/login/authenticate/2factor/${params}`
  );

  return response;
}

export async function postFinishRegistrationCodeApi(
  params: ApiCallParams<string>
) {
  const response = await requestToApi(
    `/api/registration/finish/${params}`,
    "post",
    false
  );

  return response.token;
}
